import { RSAA, isRSAA } from 'redux-api-middleware';
import ctrlUtil from '../utils/controls';
import queryString from 'qs';
import qs from 'qs';

/* TOCHECK: refactory and check for the right resource id */
const replaceUrlPlaceholders = (url, params, control) => {
  // TODO Replace object.Id with a string id

  if (control && control !== 'CTRL_ME') {
    let e = Object.keys(params).reduce((res, e) => {
      return res.replace('{Id}', typeof params === 'string' ? params : params.Id);
    }, url);
    return e;
  } else {
    let substring = 'profiles/';
    if (url.indexOf(substring) !== -1) {
      let parsed = url.split('profiles/');
      return parsed[0] + 'profiles/' + params;
    } else {
      let parsed = url.split('users/');
      return parsed[0] + 'users/' + params;
    }
  }
};

const replaceQueryStringPlaceholders = (url, params) => {
  let result = {};
  const urlParts = url.split('?');
  if (urlParts[1]) {
    const queryParams = queryString.parse(urlParts[1]);
    result = Object.keys(queryParams).reduce((res, e) => {
      if (params && params[e]) {
        res[e] = params[e];
      }
      return res;
    }, result);
  }
  return urlParts[0] + '?' + qs.stringify(result);
};

const calculateEndpoint = (href = '', queryString = {}, param = {}, control = {}) => {
  let result = href.replace(/^(?:https?:\/\/)?(?:[^@/\n]+@)?(?:www.)?([^:/\n]+)(:\d*)?/g, '');
  if (param && Object.keys(param).length > 0) {
    result = replaceUrlPlaceholders(result, param, control);
  } else if (queryString && Object.keys(queryString).length > 0) {
    result = replaceQueryStringPlaceholders(result, queryString);
  }
  return result;
};

const RequestMiddleware = store => next => action => {
  const state = store.getState();
  if (isRSAA(action)) {
    action = {
      [RSAA]: {
        ...action[RSAA],
        headers: {
          ...action[RSAA].headers,
          'Content-Type': 'application/json'
        }
      }
    };

    if (state.auth.accessToken) {
      action = {
        [RSAA]: {
          ...action[RSAA],
          headers: {
            ...action[RSAA].headers,
            Authorization: 'Bearer ' + state.auth.accessToken
          }
        }
      };
    }

    if (action[RSAA].controlKey) {
      let control = null;
      const ctrlKey = ctrlUtil.getControlKey(action[RSAA].controlKey);
      const ctrlSrc = action[RSAA].controlInstance || state.controls.items[ctrlKey];
      const ctrlAction = action[RSAA].controlAction ? action[RSAA].controlAction : 'self';
      control =
        ctrlSrc && ctrlSrc['@controls'] && ctrlSrc['@controls'][ctrlAction] ? ctrlSrc['@controls'][ctrlAction] : null;
      if (control) {
        const requestBody = action[RSAA].body;
        action = {
          [RSAA]: {
            endpoint: calculateEndpoint(
              control.href,
              action[RSAA].queryString,
              action[RSAA].param,
              action[RSAA].controlKey
            ),
            method: control.method,
            headers: { ...action[RSAA].headers },
            types: [...action[RSAA].types].map(e => {
              if (typeof e === 'object' && Object.keys(e).length > 0) {
                return {
                  ...e,
                  meta: {
                    ...e.meta,
                    controlKey: action[RSAA].controlKey,
                    control
                  }
                };
              }
              if (typeof e === 'string') {
                return {
                  type: e,
                  meta: {
                    controlKey: action[RSAA].controlKey,
                    control
                  }
                };
              }
              return e;
            })
          }
        };
        if (requestBody && typeof requestBody === 'object') {
          action[RSAA].body = JSON.stringify(requestBody);
        }
      } else {
        throw new Error(
          'Control Not Found. KEY: ' + action[RSAA].controlKey + ', ACTION: ' + (action[RSAA].controlAction || 'self')
        );
      }
    }
  }

  return next(action);
};

export default RequestMiddleware;
